import { VariableCardCombinedProps } from './types';

const usePresenter = (props: VariableCardCombinedProps): VariableCardCombinedProps => {
  return props;
};

export default usePresenter;
